if (!customElements.get("videos-slider")) {
  class videosSlider extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.sliderContainer = this.querySelector(
        ".videos-slider__videos"
      );
      this.prevButton = this.querySelector(".videos-slider__nav-button--prev");
      this.nextButton = this.querySelector(".videos-slider__nav-button--next");
      this.pagination = this.querySelector(".videos-slider__pagination");
      this.navigation = this.querySelector(".videos-slider__nav");

      this.initSlider();
    }

    initSlider() {
      if (!this.sliderContainer) return;

      this.videosSlider = new Swiper(this.sliderContainer, {
        slidesPerView: "auto",
        spaceBetween: 20,
        autoHeight: true,
        allowTouchMove: true,
        keyboard: {
          enabled: true,
          onlyInViewport: false,
          pageUpDown: false,
        },
        mousewheel: {
          enabled: true,
          forceToAxis: true,
          releaseOnEdges: true,
        },
        navigation: {
          nextEl: this.nextButton,
          prevEl: this.prevButton,
        },

        pagination: {
          el: this.pagination,
          clickable: true,
        },

        breakpoints: {
          1024: {
            spaceBetween: 43,
          },
        },

        on: {
          init: () => {
            this.updateNavigationVisibility(this.videosSlider);
          },
          resize: () => {
            this.updateNavigationVisibility(this.videosSlider);
          },
        },
      });
    }

    updateNavigationVisibility(swiper) {
      if (!swiper || !this.navigation) return;

      const realSlidesPerView =
        swiper.params.slidesPerView === "auto"
          ? swiper.slidesPerViewDynamic()
          : Number(swiper.params.slidesPerView) || 1;

      if (swiper.slides.length <= realSlidesPerView) {
        this.navigation.style.display = "none";
      } else {
        this.navigation.style.display = "";
      }
    }
  }

  customElements.define("videos-slider", videosSlider);
}
